const BYTES_PER_UNIT = 1000;
const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const;

export const bytesFromGigabytes = (gigabytes: number): number =>
  gigabytes * BYTES_PER_UNIT ** 3;

export const formatBytes = (bytes?: number | null, fallback = '—'): string => {
  if (typeof bytes !== 'number' || Number.isNaN(bytes)) {
    return fallback;
  }

  if (bytes === 0) {
    return '0 B';
  }

  let index = Math.min(
    Math.max(Math.floor(Math.log(bytes) / Math.log(BYTES_PER_UNIT)), 0),
    BYTE_UNITS.length - 1
  );
  let value = bytes / BYTES_PER_UNIT ** index;
  let decimals = value >= 10 || (index === 0 && value >= 1) ? 0 : 1;

  if (Number(value.toFixed(decimals)) >= BYTES_PER_UNIT && index < BYTE_UNITS.length - 1) {
    index += 1;
    value = bytes / BYTES_PER_UNIT ** index;
    decimals = value >= 10 || (index === 0 && value >= 1) ? 0 : 1;
  }

  return `${value.toFixed(decimals)} ${BYTE_UNITS[index]}`;
};
